export enum FeedbackAnswerQualityRatingEnum {
    NOT_AT_ALL_ACCURATE = 'Not at all accurate',
    NOT_VERY_ACCURATE = 'Not very accurate',
    SOMEWHAT_ACCURATE = 'Somewhat accurate',
    VERY_ACCURATE = 'Very accurate',
    EXTREMELY_ACCURATE = 'Extremely accurate',
}

export enum FeedbackAnswerWrongRatingEnum {
    TOO_SHORT = 'Too short',
    CONFUSING = 'Confusing',
    TOO_LONG = 'Too long',
    POOR_SOURCES = 'Poor source(s)',
    OUT_OF_DATE = 'Out of date',
    INCOMPLETE = 'Incomplete',
    OFF_TOPIC = 'Off topic',
    HALLUCINATION = 'Hallucination (made up answer)',
    GROUND_TRUTH = 'Ground truth',
    RED_TEAMING = 'Red teaming',
    OTHER = 'Other (use form below)',
}

export enum GroupPositionEnum {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
}

export enum FeedbackCategoryEnum {
    INSIGHT = 'Insights, education',
    PRODUCT = 'Products, services, tools',
    OUT_OF_SCOPE = 'Out of scope',
}

export interface FeedbackQuestion {
    question: string;
    type: number;
    answer: string;
    answers?: Array<string>;
    placeholderText?: string;
}

export enum FeedbackRatingEnum {
    GOOD = 'Good',
    OKAY = 'Okay',
    POOR = 'Poor',
}

export enum FeedbackRelatedQuestionsRatingEnum {
    NOT_AT_ALL_HELPFUL = 'Not at all helpful',
    NOT_VERY_HELPFUL = 'Not very helpful',
    SOMEWHAT_HELPFUL = 'Somewhat helpful',
    VERY_HELPFUL = 'Very helpful',
    EXTREMELY_HELPFUL = 'Extremely helpful',
}
